import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import { BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { InputText, InputTextArea } from '../../../atoms'
import STATE_CODES from 'static/stateCodes'
import AgentLayoutEdit from '../_layouts/edit'

declare var window: interfaces.IWindow

const FIELDS = {
  area: 'area',
  meetup_point: 'meetup_point',
  name_en: 'name_en',
  name_ja: 'name_ja',
  sub_area: 'sub_area',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('meetup_place', { scope: 'activerecord.models' }),
})

interface IProps {
  meetup_place?: IJsonResponse
}

const AgentMeetupPlaceEdit: React.FC<IProps> = ({ meetup_place }) => {
  const { data: meetupPlace } = utilService.getDataFromJson(meetup_place)

  const options = STATE_CODES.map(code => ({
    value: code,
    label: code,
  }))

  const initArea = React.useMemo(() => {
    const found = options.find(({ value }) => value === meetupPlace.area)
    return found ?? { value: null, label: '' }
  }, [options, meetupPlace.area])

  const [selectedArea, setSelectedArea] = React.useState(initArea.value)
  const [meetupPointURL, setMeetupPointURL] = React.useState(meetupPlace.meetup_point_url)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const result = { ...values, area: selectedArea, meetup_point_url: meetupPointURL }

      const { flush } = await agentService.updateMeetupPlace(meetupPlace.id, result)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/agent/meetup_places'
    },
    [selectedArea, meetupPointURL]
  )
  const handleAreaChange = selectedOption => {
    setSelectedArea(selectedOption ? selectedOption.value : null)
  }

  return (
    <AgentLayoutEdit
      model="meetup_places"
      title={title}
      fields={FIELDS}
      indexLink="/agent/meetup_places"
      formItems={
        <>
          <input type="hidden" name="area" value={selectedArea || ''} />
          <S.FormItemWrapper>
            <S.ReactSelectWrapper>
              <p className="ReactSelect_Title">
                {I18n.t('generic.area')}
                <span className="InputText_Required">{I18n.t('generic.required')}</span>
              </p>
              <div className="ReactSelect_Main">
                <ReactSelect
                  placeholder="選択してください"
                  options={options}
                  defaultValue={initArea}
                  onChange={handleAreaChange}
                  menuPortalTarget={document.querySelector('body')}
                />
              </div>
            </S.ReactSelectWrapper>
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="sub_area"
              defaultValue={meetupPlace.sub_area}
              label="Sub Area"
              placeholder="新宿, 渋谷"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="name_ja"
              defaultValue={meetupPlace.name_ja}
              label="ホテル名"
              placeholder="リッツカールトン"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={true}
              name="name_en"
              defaultValue={meetupPlace.name_en}
              label="ホテル名(英語)"
              placeholder="Ritz Carlton"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputTextArea
              required={false}
              name="meetup_point"
              defaultValue={meetupPlace.meetup_point}
              label="集合場所"
              placeholder="The 1st floor concierge desk of Tokyo Station Hotel"
            />
          </S.FormItemWrapper>
          <S.FormItemWrapper>
            <InputText
              required={false}
              name=""
              defaultValue={meetupPlace.meetup_point_url}
              label="ホテルのURL"
              placeholder="https://testhotel.com/"
              onChangeHandler={e => setMeetupPointURL(e.target.value)}
              onBlurHandler={e => setMeetupPointURL(e.target.value)}
            />
          </S.FormItemWrapper>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.FormItemWrapper = styled.div`
  margin-top: 24px;
  .note {
    margin-left: 180px;
    font-size: 14px;
    margin-top: 5px;
    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      margin-left: 0px;
    }
  }
`
S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 180px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    .InputText_Required {
      display: inline-block;
      border-radius: 3px;
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.caution};
      vertical-align: middle;
      font-size: 11px;
      font-weight: normal;
      padding: 4px 6px;
      margin-left: 8px;
    }

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`

export default AgentMeetupPlaceEdit
